import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ApplicationUserViewModel } from '../../../models';
import { PossibleIcons } from './PossibleIcons';
import { DisplayInfo } from '../DisplayInfo';

class WorkflowTriggerCell implements angular.IComponentController {
    approvalLevels: number[];
    content: string;
    icon: PossibleIcons = {};
    user: ApplicationUserViewModel;
    
    readonly displayInfo: DisplayInfo;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if(changesObj['displayInfo'] && this.displayInfo){
            this.icon = this.displayInfo.icon;
            this.content = this.displayInfo.content;
            this.approvalLevels = this.displayInfo.approvalLevels;
            this.user = this.displayInfo.user;
        }
    }
}

export const wtWorkflowTriggerCell: ComponentDefinition = {
    componentId: 'wtWorkflowTriggerCell',
    controller: WorkflowTriggerCell,
    template: require('./workflowTriggerCell.component.html'),
    controllerAs: 'vm',
    bindings: {
        displayInfo: '<'
    }
};